export { default } from './ProductSelectModal'



// WEBPACK FOOTER //
// ./src/App/components/ProductSelectModal/index.js